import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { ListProps, ListSelectionType } from './List.interface';
import './List.css';
import { ListEmptyPlaceholder } from './ListEmptyPlaceholder';
import { ListRow } from './ListRow';

/**
 * A generic list component
 */
export const List: React.FC<ListProps> = ({
  entries,
  className,
  selectionType,
  onSelectionChange,
  selectedIndices,
}) => {
  const [internalSelectedEntries, setInternalSelectedEntries] = useState<
    number[]
  >([]);

  // Synchronisiere internen State mit externen selectedIndices
  useEffect(() => {
    if (selectedIndices !== undefined) {
      setInternalSelectedEntries(selectedIndices);
    }
  }, [selectedIndices]);

  const selectedEntries = internalSelectedEntries;

  const updateSelection = (newSelection: number[]) => {
    setInternalSelectedEntries(newSelection);

    if (onSelectionChange) {
      onSelectionChange(newSelection);
    }
  };

  const getRowClickHandler = () => {
    switch (selectionType) {
      case ListSelectionType.Multi:
        return handleMultiSelection;
      case ListSelectionType.Single:
        return handleSlingleSelection;
    }
  };

  const handleMultiSelection = (index: number) => {
    if (selectedEntries.includes(index)) {
      const newSelection = selectedEntries.filter(item => item !== index);
      updateSelection(newSelection);
    } else {
      const newSelection = [...selectedEntries, index];
      updateSelection(newSelection);
    }
  };

  const handleSlingleSelection = (index: number) => {
    updateSelection([index]);
  };

  const rowClickHandler = getRowClickHandler();

  return (
    <ul className={cn('list', className ?? '')}>
      {entries.length === 0 && <ListEmptyPlaceholder />}
      {entries.map((entry, index) => (
        <ListRow
          key={index}
          entry={entry}
          isSelected={selectedEntries.includes(index)}
          isSelectable={
            selectionType !== ListSelectionType.None &&
            (entry.selectionDisabled === undefined ||
              entry.selectionDisabled === false)
          }
          onClick={
            rowClickHandler ? rowClickHandler.bind(this, index) : undefined
          }
        />
      ))}
    </ul>
  );
};
